import script from "./BackgroundDotsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundDotsComponent.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundDotsComponent.vue?vue&type=style&index=0&id=b32731e8&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b32731e8"]])

export default __exports__